export default __webpack_public_path__ + "static/media/FPViewIconWhite.2c27e590.svg";